import React, { useState } from 'react';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import { ChatMessage } from '../../store/slices/chatSlice';

interface ChatRoomProps {
  projectId: string;
  className?: string;
}

const ChatRoom: React.FC<ChatRoomProps> = ({ projectId, className = '' }) => {
  const [replyingTo, setReplyingTo] = useState<ChatMessage | null>(null);

  const handleReply = (message: ChatMessage) => {
    setReplyingTo(message);
  };

  const handleReplyCancel = () => {
    setReplyingTo(null);
  };

  return (
    <div className={`flex flex-col h-96 bg-[var(--color-default-background)] rounded-lg border border-[var(--color-neutral-border)] ${className}`}>
      <div className="flex-1 overflow-y-auto p-4 bg-[var(--color-neutral-50)]">
        <ChatMessages projectId={projectId} onReply={handleReply} />
      </div>
      <ChatInput
        projectId={projectId}
        parentMessage={replyingTo}
        onReplyCancel={handleReplyCancel}
      />
    </div>
  );
};

export default ChatRoom;

